module.exports = __webpack_public_path__ + "img/d13.908fc8a1.png";